module.exports = __webpack_public_path__ + "static/img/header.10a1c4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header.png
// module id = C/5X
// module chunks = 68